import { Outlet } from 'react-router-dom';

import { AuthBody, AuthContainer } from '../styles/auth-layout';

import { ReactComponent as LogoStaging } from 'assets/icons/logo-staging.svg';
import { ReactComponent as Logo } from 'assets/icons/logo.svg';

import { REACT_APP_ENV } from 'constants/environment';

const AuthLayout = () => {
  return (
    <AuthContainer>
      {REACT_APP_ENV === 'staging' ? (
        <div style={{ maxWidth: 200 }}>
          <LogoStaging style={{ width: '100%', height: '100%' }} />
        </div>
      ) : (
        <Logo />
      )}
      <AuthBody>
        <Outlet />
      </AuthBody>
    </AuthContainer>
  );
};

export { AuthLayout };
